import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import {
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Layout, Menu } from "antd";
import AssessmentsPage from "./components/pages/AssessmentsPage";
import TeachersPage from "./components/pages/TeachersPage";
import EditMarkPage from "./components/pages/EditMarkPage";
import StudentPage from "./components/pages/StudentPage";
import StudentGradePage from "./components/pages/StudentGradePage";
import LessonPlanPage from "./components/pages/LessonPlanPage";
import LessonCreatePage from "./components/pages/LessonCreatePage";
import ExamCreatePage from "./components/pages/ExamCreatePage";
import LessonUpdatePage from "./components/pages/LessonUpdatePage";
import LogIn from "./components/pages/LogIn";
import HomePage from "./components/pages/home";
import StreamCreatePage from "./components/pages/StreamCreatePage";
import StreamPage from "./components/pages/StreamPage";
import UpdateAuthPage from "./components/pages/UpdateAuthPage";
import AssessmentsByGroups from "./components/pages/AssessmentsByGroups";
import TeacherPageForOffice from "./components/pages/TeacherPageForOffice";
import { Navigate, Link, Route, Routes } from "react-router-dom";
import AuthService from "./services/auth.service";
import EventBus from "./common/EventBus";
import FinalAssessmentPage from "./components/pages/FinalAssessmentModal/FinalAssessmentModal";

const { Header, Content, Footer, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const App = () => {
  const [showTeacherBoard, setShowTeacherBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [showOfficeBoard, setShowOfficeBoard] = useState(false);
  const [showStudentBoard, setShowStudentBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);
  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setCurrentUser(user);
      setShowTeacherBoard(user.roles?.includes("ROLE_TEACHER"));
      setShowOfficeBoard(user.roles?.includes("ROLE_OFFICE"));
      setShowStudentBoard(user.roles?.includes("ROLE_STUDENT"));
      setShowAdminBoard(user.roles?.includes("ROLE_ADMIN"));
    }

    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, []);

  const logOut = () => {
    AuthService.logout();
    setShowTeacherBoard(false);
    setShowOfficeBoard(false);
    setShowStudentBoard(false);
    setShowAdminBoard(false);
    setCurrentUser(undefined);
  };

  const [collapsed, setCollapsed] = useState(false);
  return (
    <Layout
      style={{
        minHeight: "100vh",
      }}
    >
      {currentUser && (
        <Sider
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
        >
          <div className="logo" />
          <Menu theme="dark" defaultSelectedKeys={["1"]} mode="inline">
            <Menu.Item>
              <Link to={"/home"}>Главная</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to={"/update-auth-page"}>Изменить данные</Link>
            </Menu.Item>
            {showTeacherBoard && (
              <Menu.Item>
                <Link to={"/"}>Журнал</Link>
              </Menu.Item>
            )}
            {showOfficeBoard && (
              <Menu.Item>
                <Link to={"/stream-create-page"}>Создать поток</Link>
              </Menu.Item>
            )}
            {showOfficeBoard && (
              <Menu.Item>
                <Link to={"/stream-page"}>Все потоки</Link>
              </Menu.Item>
            )}
            {showOfficeBoard && (
              <Menu.Item>
                <Link to={"/assessments-by-groups"}>Журналы</Link>
              </Menu.Item>
            )}

            <Menu.Item>
              <a href="/login-page" onClick={logOut}>
                LogOut
              </a>
            </Menu.Item>
          </Menu>
        </Sider>
      )}
      <Routes>
        <Route
          path="/home"
          element={
            typeof currentUser === "undefined" ? <LogIn /> : <HomePage />
          }
        />
        <Route
          path="/update-auth-page"
          element={
            typeof currentUser === "undefined" ? <LogIn /> : <UpdateAuthPage />
          }
        />
        <Route
          path="/"
          element={showTeacherBoard === false ? <LogIn /> : <TeachersPage />}
        />

        <Route path="/login-page" element={<LogIn />} />
        <Route
          path="/assessments-page/teacher-id/:teacherId/stream-id/:streamId"
          element={
            showTeacherBoard === true || showOfficeBoard === true ? (
              <AssessmentsPage />
            ) : (
              <LogIn />
            )
          }
        />
        <Route
          exact
          path="/lesson-plan-page/teacherId/:teacherId/stream-id/:streamId"
          element={
            showTeacherBoard === true || showOfficeBoard === true ? (
              <LessonPlanPage />
            ) : (
              <LogIn />
            )
          }
        />
        <Route
          path="/lesson-update-page/edit/teacherId/:teacherId/stream-id/:streamId/:id"
          element={
            showTeacherBoard === true || showOfficeBoard === true ? (
              <LessonUpdatePage />
            ) : (
              <LogIn />
            )
          }
        />
        <Route
          path="/lesson-create-page/teacherId/:teacherId/stream-id/:streamId"
          element={
            showTeacherBoard === true || showOfficeBoard === true ? (
              <LessonCreatePage />
            ) : (
              <LogIn />
            )
          }
        />
        <Route
          path="/exam-create-page/stream-id/:streamId"
          element={
            showTeacherBoard === true || showOfficeBoard === true ? (
              <ExamCreatePage />
            ) : (
              <LogIn />
            )
          }
        />

        <Route
          path="/stream-create-page"
          element={showOfficeBoard === false ? <LogIn /> : <StreamCreatePage />}
        />
        <Route
          path="/stream-page"
          element={showOfficeBoard === false ? <LogIn /> : <StreamPage />}
        />
        <Route
          path="/assessments-by-groups"
          element={
            showOfficeBoard === false ? <LogIn /> : <AssessmentsByGroups />
          }
        />
        <Route
          path="/teacher-page-for-office/:teacherId"
          element={
            showOfficeBoard === false ? <LogIn /> : <TeacherPageForOffice />
          }
        />
      </Routes>
    </Layout>
  );
};

export default App;
